var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',_vm._g(_vm._b({},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item){return _c('el-option',{key:item[_vm.valueKey],attrs:{"label":item[_vm.labelKey],"value":item[_vm.valueKey],"disabled":item[_vm.disabledKey]}},[_vm._t("custom",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }